import React, { useContext, useEffect, useState } from "react";
import { Layout, Modal, Button, Form, message } from "antd";
// import { RiMailSendLine } from "react-icons/ri";
import { Switch, Route, Redirect } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";
import {
  Deliveries,
  Create,
  Dashboard,
  Reports,
  Admin,
  Infos,
  SolutionCenter,
  Invoices,
} from "@MODULES";
import {
  FiltersProvider,
  DrawerProvider,
  AuthContext,
  AppContext,
} from "@CONTEXTS";
import { AppRouter } from "@MASTER";
import {
  // HJCreateFeedback,
  HJChangePassword,
} from "@FORMS";
// import { createFeedBack } from "@FEEDBACKS";
import { changePassword } from "@USERS";
import { useHistory } from "react-router-dom";
import "./index.scss";
const { Content } = Layout;

const {
  info,
  // , success
} = Modal;
const PrivateLayout = () => {
  // const [form] = Form.useForm();
  const [passwordForm] = Form.useForm();
  // const [visible, setVisible] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [changingMerchant, setChangingMerchant] = useState(false);
  const {
    info: {
      announcements,
      dashboardDisabled,
      operationDisabled,
      passwordExpired,
    },
  } = useContext(AuthContext);
  const { isCollapsed } = useContext(AppContext);
  const history = useHistory();
  useEffect(() => {
    if (dashboardDisabled && operationDisabled) {
      history.push("/info/company-info");
    } else if (dashboardDisabled && !operationDisabled) {
      history.push("/deliveries/operation");
    } else if (!dashboardDisabled && operationDisabled) {
      history.push("/dashboard");
    }
  }, [dashboardDisabled, operationDisabled]);
  useEffect(() => {
    let seenAnnouncements =
      JSON.parse(localStorage.getItem("announcements")) || [];
    let notSeenAnnouncements = [...announcements];
    seenAnnouncements?.forEach((item) => {
      notSeenAnnouncements = notSeenAnnouncements.filter(
        (i) => i._id === item.id
      );
    });

    notSeenAnnouncements.forEach((item) => {
      info({
        title: item.title,
        content: <div dangerouslySetInnerHTML={{ __html: item.message }}></div>,
        onOk() {},
      });
    });
    localStorage.setItem("announcements", JSON.stringify(announcements));
  }, []);

  // const sendFeedBack = async (values) => {
  //   setLoading(true);

  //   const response = await createFeedBack(values);
  //   setLoading(false);
  //   if (response._id) {
  //     setVisible(false);
  //     success({
  //       content: (
  //         <div className="feedback-success-container">
  //           <RiMailSendLine />
  //           <h2>Geri bildiriminiz için teşekkür ederiz.</h2>
  //         </div>
  //       ),
  //       onOk() {},
  //       okText: "Kapat",
  //       width: 1100,
  //       centered: true,
  //       closable: true,
  //     });
  //     form.setFieldsValue({ email: null, fullName: null, message: null });
  //   } else {
  //     message.error({
  //       content: response.response.data.error.msg,
  //       className: "app-error-message",
  //     });
  //   }
  // };
  const handleChangePassword = () => {
    setPasswordLoading(true);
    try {
      passwordForm.validateFields().then(async (values) => {
        const response = await changePassword(values);
        if (response?.success) {
          setTimeout(() => {
            history.go(0);
          }, 1000);
        } else {
          response?.error?.msg &&
            message.error({
              content: response?.error?.msg,
              className: "app-error-message",
            });
        }
      });
    } catch (error) {
    } finally {
      setPasswordLoading(false);
    }
  };
  return (
    <FiltersProvider>
      <DrawerProvider>
        <Layout>
          <Sidebar />
          <Layout
            className={`site-layout${
              !isCollapsed ? " site-layout--expanded" : ""
            }`}
          >
            <Header setChangingMerchant={setChangingMerchant} />
            {!changingMerchant && (
              <Content>
                <Switch>
                  {!dashboardDisabled && (
                    <AppRouter
                      path="/dashboard"
                      component={Dashboard}
                      title="Ana Sayfa"
                    />
                  )}
                  <AppRouter
                    path="/create"
                    component={Create}
                    title="Gönderi Oluştur"
                  />
                  <AppRouter
                    path="/deliveries"
                    component={Deliveries}
                    title="Gönderi Listesi"
                  />
                  <AppRouter
                    path="/reports"
                    component={Reports}
                    title="Raporlar"
                  />
                  <AppRouter
                    path="/admin"
                    component={Admin}
                    title="Yönetim Modülü"
                  />
                  <AppRouter
                    path="/invoices"
                    component={Invoices}
                    title="Cari Hesap Detayları"
                  />
                  <AppRouter path="/info" component={Infos} title="Bilgiler" />
                  <AppRouter
                    path="/cozummerkezi"
                    component={SolutionCenter}
                    title="Çözüm Merkezi"
                  />

                  <Route path="*">
                    <Redirect to="/dashboard" />
                  </Route>
                </Switch>
              </Content>
            )}
            <Button
              size="large"
              onClick={() => history.push("/cozummerkezi/destek-talepleri")}
              className="feed-back-button"
            >
              Bize Ulaşın
            </Button>
            {/* <Modal
              visible={visible}
              title={"Bize Ulaşın"}
              width={1100}
              centered
              okText="Gönder"
              confirmLoading={loading}
              onCancel={() => {
                setVisible(false);
              }}
              onOk={() => {
                form.validateFields().then((values) => {
                  sendFeedBack(values);
                });
              }}
            >
              <Form form={form} layout="vertical">
                <HJCreateFeedback form={form} />
              </Form>
            </Modal> */}

            <Modal
              visible={passwordExpired}
              closable={false}
              title={"Şifre Değiştir!"}
              width={750}
              centered
              maskClosable={false}
              confirmLoading={passwordLoading}
              footer={null}
            >
              <Form
                form={passwordForm}
                layout="vertical"
                onFinish={handleChangePassword}
              >
                <HJChangePassword form={passwordForm} />
                <Button type="primary" htmlType="submit">
                  Şifreyi Değiştir
                </Button>
              </Form>
            </Modal>
          </Layout>
        </Layout>
      </DrawerProvider>
    </FiltersProvider>
  );
};

export default PrivateLayout;
